import { getCurrencySymbol } from "@features/helpers";

export const CHALLENGE_100K_V5_PAYWALL_STEP = 31;
export const CHALLENGE_100K_V5_DISCOUNT_PAYWALL_STEP = 32;

export const challenge100kV5Ids = [
    "55ec4877-c01b-4457-af1a-0ac30a22a21c",
    "0d9a2994-55e1-46ef-a6a0-272edb24acd0",
    "fe6e434a-0df5-4a62-8376-fff334ad835b"
];

export const challenge100kV5WithDiscountIds = [
    "efeb3059-4efd-4f70-8aa2-298851d0500b",
    "86a2d793-7621-47fe-b421-cf82b5741173",
    "b42be83a-3f88-4b42-aab9-bfa315c594bf"
];

export const getPaymentInfo100kV5 = (
    id: string,
    currency: string,
    priceBefore: number,
    priceAfter: number,
    buttonText: string
) => {
    const currencySymbol = getCurrencySymbol(currency);
    const formatPriceBefore = (priceBefore / 100).toFixed(2);
    const formatPriceAfter = (priceAfter / 100).toFixed(2);
    switch (id) {
        case "55ec4877-c01b-4457-af1a-0ac30a22a21c":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "0d9a2994-55e1-46ef-a6a0-272edb24acd0":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "fe6e434a-0df5-4a62-8376-fff334ad835b":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 52-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 52 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "efeb3059-4efd-4f70-8aa2-298851d0500b":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "86a2d793-7621-47fe-b421-cf82b5741173":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "b42be83a-3f88-4b42-aab9-bfa315c594bf":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 52-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 52 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
    }
};

export const paywall100kV5Feedbacks = [
    {
        author: "@starter_jess",
        comment:
            "The content is super clear and beginner-friendly. It covers exactly what you need to get started with AI no fluff, just value. Perfect if you're just stepping into this world."
    },
    {
        author: "@echsavvy_omar",
        comment:
            "Tixu.ai provides a huge variety of tools and interactive lessons that break down complex AI concepts into something anyone can grasp. It’s a fresh and modern way to learn AI — props to the creators!"
    },
    {
        author: "@growwithzoe",
        comment:
            "Tixu.ai helped me level up faster than I expected. The personalized approach and easy-to-follow lessons made learning smooth and impactful. I now feel more confident and focused on my next career goals."
    }
];

export const paywall100kV5Benefits_old = [
    "Learn to create and sell with AI — from art to chatbots",
    "Discover AI tools that save time and make money",
    "Launch AI-powered projects in just 28 days"
];

export const paywall100kV5Benefits = [
    [
        "Learn to ",
        { text: "create", highlight: true },
        " and ",
        { text: "sell", highlight: true },
        " with AI — from art to chatbots"
    ],
    [
        "Discover AI tools that ",
        { text: "save time", highlight: true },
        " and ",
        { text: "make money", highlight: true }
    ],
    ["Launch AI-powered projects ", { text: "in just 28 days", highlight: true }]
];

export const screenShotes100kV5 = [
    "/images/onboarding/png/paywall/screen-1.png",
    "/images/onboarding/png/paywall/screen-2.png",
    "/images/onboarding/png/paywall/screen-3.png"
];
